import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { initializeGA4, removeGA4, trackPageView, isAnalyticsEnabled } from '../config/analytics'

export const CONSENT_CHANGED_EVENT = 'cookie-consent-updated'

const useAnalytics = () => {
  const location = useLocation()
  const prevPath = useRef(null)

  useEffect(() => {
    if (isAnalyticsEnabled()) {
      initializeGA4()
    }

    const handleConsentChange = () => {
      if (isAnalyticsEnabled()) {
        initializeGA4()
      } else {
        removeGA4()
      }
    }

    window.addEventListener(CONSENT_CHANGED_EVENT, handleConsentChange)
    return () => {
      window.removeEventListener(CONSENT_CHANGED_EVENT, handleConsentChange)
    }
  }, [])

  useEffect(() => {
    const currentPath = location.pathname + location.search
    if (prevPath.current === currentPath) return
    prevPath.current = currentPath

    trackPageView(currentPath, document.title)
  }, [location])
}

export default useAnalytics
